// In-game panel: optional top slot, headline, go to game (shared with Player page later)

import React from 'react';
import { Button } from '@/components/ui/button';

export interface GameInProgressPanelProps {
  onGoToGame: () => void;
  topSlot?: React.ReactNode;
}

const GameInProgressPanel: React.FC<GameInProgressPanelProps> = ({
  onGoToGame,
  topSlot,
}) => {
  return (
    <div className="flex flex-col items-center justify-center gap-4 sm:gap-6 md:gap-8">
      {topSlot}
      <h2 className="m-0 text-xl font-bold text-foreground sm:text-2xl">
        Game in progress
      </h2>
      <Button
        type="button"
        size="xl"
        className="w-full max-w-[240px] cursor-pointer"
        onClick={onGoToGame}
      >
        Go to game
      </Button>
    </div>
  );
};

export default GameInProgressPanel;
